// extracted by mini-css-extract-plugin
module.exports =  {"size-lg":"xV1JUU1","sizeLg":"xV1JUU1","size-md":"Rj3rptM","sizeMd":"Rj3rptM","size-sm":"ihacqjI","sizeSm":"ihacqjI"};